import Glide from '@glidejs/glide'

export default function carousel(){
  const carousels = document.querySelectorAll('.glide-reviews');

  carousels.forEach(element => {
    new Glide (element).mount()
  });

  const timeline = document.querySelector('.glide-timelines');

  let timelineSlider = new Glide(timeline,{
    gap: 20,
    keyboard: false,
    loope:true,
  })

  timelineSlider.mount();
}